














import Component from 'vue-class-component';

import { BaseVue } from '../../BaseVue';
import Wallets from '../../components/org/OrgWallets.vue';
@Component({
  components: {
    Wallets,
  },
})
export default class WalletsClass extends BaseVue {
  public selectedTab = 0;
}
